module.exports = __webpack_public_path__ + "img/唐门女.f191be09.png";